if (window.innerWidth < 669) {
    // Получаем все элементы с классом format-life__card
    const cards = document.querySelectorAll('.format-life__card');

    // Добавляем обработчик события клика для каждой карточки
    cards.forEach((card) => {
        // Проверяем, содержит ли элемент класс "fixed"
        if (!card.classList.contains('fixed')) {
            // Обработчик клика
            const handleClick = function() {
                // Проверяем, активен ли текущий элемент
                const isActive = card.classList.contains('active');

                // Получаем высоту содержимого
                const content = card.querySelector('.format-life__content');
                const contentHeight = content.offsetHeight + 40;

                // Устанавливаем длительность анимации
                const animationDuration = 500;

                // Если элемент уже активен, убираем класс active и возвращаем высоту в исходное положение
                if (isActive) {
                    card.classList.remove('active');
                    card.style.minHeight = '';
                } else {
                    // Если элемент не активен, добавляем класс active и устанавливаем высоту равной высоте содержимого
                    card.classList.add('active');
                    card.style.minHeight = `${contentHeight}px`;
                }

                // Добавляем анимацию изменения высоты
                card.style.transition = `min-height ${animationDuration / 1000}s`;
            };

            // Добавляем обработчик клика
            card.addEventListener('click', handleClick);
        }
    });

    // Добавляем обработчик клика по документу для закрытия активного элемента при клике вне его
    document.addEventListener('click', (event) => {
        cards.forEach((card) => {
            // Проверяем, является ли элемент, по которому кликнули, дочерним элементом активного элемента
            const isClickedInsideActiveCard = card.contains(event.target);

            // Если клик был сделан не внутри активного элемента, закрываем его
            if (!isClickedInsideActiveCard) {
                card.classList.remove('active');
                card.style.minHeight = '';
            }
        });
    });
}
